import React, { useEffect, useState } from "react";
import { Button, IconButton } from "@mui/material";
import Grid from "@mui/material/Grid2";
import TotaltemplateIcon from "./../../Assets/totaltemplates.svg";
import ActiveexperienceIcon from "./../../Assets/activeExperiernce.svg";
import OfflineexperienceIcon from "./../../Assets/offlineexperience.svg";
import { ReactComponent as CopiedIcon } from "./../../Assets/copy.svg";
import { ReactComponent as EyeIcon } from "./../../Assets/eye.svg";
import { ReactComponent as EyehideIcon } from "./../../Assets/eye_hide.svg";
import { ReactComponent as InfoIcon } from "./../../Assets/info.svg";
import logothumbnail from "./../../Assets/thumbnail-logo.svg";
import { fetchTileDetails, getNationDetails } from "../../Services/DashboardApi";
import { Link } from "react-router-dom";
function Dashboard() {
  const [showApiToken, setShowApiToken] = useState(false);
  const [showPrivateKey, setShowPrivateKey] = React.useState(false);
  const [nationDetails, setNationDetails] = useState<any>();
  const [tileDetails, setTileDetails] = useState<any>();

  const handleClickShowApiToken = () => {
    setShowApiToken((prev: any) => !prev);
  };
  const handleClickShowPrivateKey = () => setShowPrivateKey((prev) => !prev);

  useEffect(() => {
    const fetchNationDetails = async () => {
      const data = await getNationDetails();
      if (!data.error) {
        setNationDetails(data.tenant);
      }
    };
    const getTileDetails = async () => {
      const response = await fetchTileDetails();
      if (response.success === true) {
        setTileDetails(response);
      }else{
        console.error("Error fetching tile details:", response);
      }
    };
    getTileDetails();
    fetchNationDetails();
  }, []);
  const maskValue = (value: string | undefined, isVisible: boolean) => {
    if (!value) return "**********";
    return isVisible ? value : `${"*".repeat(value.length)}`; 
  };
  const handleCopy = (text: string | undefined) => {
    if (text) {
      navigator.clipboard.writeText(text);
    }
  };

  return (
    <div className="dashboard">
      <h2>Experience Management Portal</h2>
      <div className="dashboard__grid">
        <div className="dashboard__grid--item">
          <div className="dashboard__grid--icon">
            <img src={TotaltemplateIcon} alt="Totaltemplate Icon" />
          </div>
          <div className="dashboard__grid--count">
            <h2>{tileDetails?.total_templates}</h2>
            <p>Total template</p>
          </div>
        </div>
        <div className="dashboard__grid--item">
          <div className="dashboard__grid--icon">
            <img src={ActiveexperienceIcon} alt="Activeexperience Icon" />
          </div>
          <div className="dashboard__grid--count">
            <h2>{tileDetails?.active_experiences}</h2>
            <p>Active experience</p>
          </div>
        </div>
        <div className="dashboard__grid--item">
          <div className="dashboard__grid--icon">
            <img src={OfflineexperienceIcon} alt="Offlineexperience Icon" />
          </div>
          <div className="dashboard__grid--count">
            <h2>{tileDetails?.offline_experiences}</h2>
            <p>Offline experience</p>
          </div>
        </div>
      </div>

      <Grid container spacing={2} className="dashboard--card">
        <Grid  size={{ xs: 12, md: 2, sm: 12 }} className="dashboard--card_logo">
          <div>
            <img src={logothumbnail} alt="Totaltemplate Icon" />
          </div>
        </Grid>
        <Grid size={{ xs: 12, md: 10, sm: 12 }} className="dashboard--card_content">
          <Grid container spacing={5}>
            <Grid size={{ xs: 12, md: 3, sm: 12 }} className="business-card__header">
              <h2>{nationDetails?.name}</h2>
            </Grid>
            <Grid size={{ xs: 12, md: 8, sm: 12 }} className="business-card__link">
              <Link to={nationDetails?.url} target="_blank">
                {nationDetails?.url}
              </Link>
              <span className="business-card__copy-icon">
                {" "}
                <Button
                  sx={{ minWidth: "auto" }}
                  onClick={() => handleCopy(nationDetails?.url)}
                >
                  <CopiedIcon fontSize="small" />
                </Button>
              </span>
            </Grid>
          </Grid>
          <Grid container mt={1} alignItems={'center'} gap={'10px'}>
            <Grid size={{ xs: 12, md: 5, sm: 12 }} className="business-card__header">
              <h6>
                <IconButton onClick={handleClickShowApiToken} edge="end"  className="Icon" sx={{marginRight:'1px'}}>
                  {showApiToken ? <EyeIcon /> : <EyehideIcon />}
                </IconButton>{" "}
                API token :
              
              </h6>
              <span className="api_token">
                  {" "}
                  {maskValue(nationDetails?.api_token, showApiToken)}
                </span>{" "}
            </Grid>
            <Grid size={{ xs: 12, md: 5, sm: 12 }} className="business-card__header">
              <h6>

              <IconButton edge="end" className="Icon" sx={{marginRight:'1px'}}>
              <InfoIcon/>
                  
                  </IconButton> Private Key :    <IconButton  onClick={handleClickShowPrivateKey} >{showPrivateKey ? <EyeIcon /> : <EyehideIcon />} </IconButton> 
                <span className="api_token">
                  {" "}
                  {maskValue(nationDetails?.private_key, showPrivateKey)}
                
                </span>{" "}
              </h6>
            </Grid>
            </Grid>
            <Grid container mt={1} alignItems={'center'} gap={'10px'}>
            <Grid size={{ xs: 12, md: 6, sm: 12 }} className="business-card__header">
              <h6>
              <IconButton   className="Icon" sx={{marginRight:'1px'}}>
                  <InfoIcon/>
                  </IconButton> Application ID : <span >{nationDetails?.application_id}</span>{" "}
              </h6>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}

export default Dashboard;
